<template>
  <div @click="$emit('click')" style="cursor: pointer; display: inline-block;">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="35"
      viewBox="0 0 512 512"
    >
      <path
        :fill="isDarkTheme ? headingTextColor : '#ffffff'"
        d="M427 234.625H167.296l119.702-119.702L256 85 85 256l171 171 29.922-29.924-118.626-119.701H427v-42.75z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "BackIcon",
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    headingTextColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null;
    }
  }
};
</script>

<style scoped>
/* div:hover {
  opacity: 0.7;
  transition: opacity 0.2s;
} */
</style>
